import { render } from "./returnGoods.vue?vue&type=template&id=6f15f03d&scoped=true&ts=true"
import script from "./returnGoods.vue?vue&type=script&lang=ts"
export * from "./returnGoods.vue?vue&type=script&lang=ts"

import "./returnGoods.vue?vue&type=style&index=0&id=6f15f03d&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f15f03d"]])

export default __exports__